import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { DataContextService } from '../services/datacontext.service';
import { UserSettingsService } from '../services/user-settings.service';
import { StartupService } from '../services/startup.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private msalService: MsalService,
    private dataContextService: DataContextService,
    private userSettingsService: UserSettingsService,
    private startupService: StartupService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<any> | boolean | any {
    if (!window['hotelingDataToken'] && this.msalService.instance.getAllAccounts()[0]) {
      return this.startupService.authorizeUser().catch((err) => {
        this.msalService.loginRedirect();
        return false;
      });
    } else if (window['hotelingDataToken'] && this.msalService.instance.getAllAccounts()[0]) {
      if (!DataContextService.UserData.hasConciergeRights) {
        this.router.navigate(['/AccessDenied']);
      }
      return true;
    }
  }
}
